import { AEMOptions } from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { AEMAlertItem } from "@AEM/models/AEMResponse.model"
import { createItemsArrayMapper } from "@AEM/AEMContentMapper"
export const useAEMAlertsData = (options?: AEMOptions) => {
	const { data, isLoading, error, refetch } = useAEMContent(
		AEMPageType.ALERTS,
		{ ...options, mapper: createItemsArrayMapper() }
	) as UseQueryResult<AEMAlertItem[]>

	const alertsData = data

	return { alertsData, isLoading, error, refetch }
}
